import React from "react";
import { useState } from "react";
import demoVideo from "../images/mobile-application.gif";

const OneStep = () => {
	const [toggle, setToggle] = useState();
	const changeToggle = (index) => {
		setToggle(index);
		// console.log(index)
	};
	return (
		<div className="max-w-[1200px] flex mx-auto my-20 space-x-5">
			<div className="full grid md:grid-cols-2 grid-cols-1 gap-10">
				<div
					id="d1"
					className="w-full flex flex-col w-full bg-gray justify-center border border-gray-300 rounded-3xl bg-gray-200 p-10"
				>
					<div className="flex flex-col w-full">
						<h1 className="text-4xl font-bold w-full text-center">
							Your one-stop, Web3 wallet
						</h1>
						<p className="text-xl my-6 w-full text-center">
							Buy, sell, and swap crypto, stake rewards and
							discover DApps, all in one place.
						</p>
						<div
							id="d2"
							className="flex md:hidden items-center justify-center  w-full"
						>
							<img
								src={demoVideo}
								alt="Example GIF"
								className="h-full w-full object-cover rounded-3xl"
							/>
						</div>
						{/* <div className="bg-blue-700 text-white sm:w-max w-full text-center px-6 font-semibold py-3 rounded-2xl my-5 ">
							Download Mobile App
						</div> */}

						<button
							className={`sm:w-max w-full  text-center flex justify-center items-center blue  relative serviceCardAnimation  overflow-hidden rounded-full my-10 duration-500 max-w-[50n0px] ${
								toggle === 1 ? "text-black" : "text-white"
							}`}
							onMouseOver={() => changeToggle(1)}
							onMouseOut={() => changeToggle(0)}
							href="#download"
						>
							<h5 className="w-full h-full bg-sky-500 z-0 rounded-full"></h5>
							<h1 className="z-50 bg-transparent text-[0.9375rem] px-[2.5rem] py-[0.75rem] font-medium">
								Download Mobile App
							</h1>
						</button>
					</div>
				</div>
				<div
					id="d2"
					className="md:flex hidden items-center justify-center  w-full"
				>
					<img
						src={demoVideo}
						alt="Example GIF"
						className="h-full w-full object-cover rounded-3xl"
					/>
				</div>
			</div>
		</div>
	);
};

export default OneStep;
